<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-horizontal">
        <div
          v-if="$route.name === 'create-commune'"
          :class="{ 'has-error': validations.code }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="code"
          >{{ $t("label.code") }}</label>
          <div class="col-sm-9">
            <input
              id="code"
              v-model="commune.code"
              :placeholder="$t('label.code')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.code">
              <FiledIsRequired :msg="validations['code'][0]" />
            </template>
          </div>
        </div>

        <div
          v-if="$route.name === 'create-commune'"
          :class="{ 'has-error': validations.parent_code }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="parent_code"
          >{{ $t("label.districtOrCityCode") }}</label>
          <div class="col-sm-9">
            <input
              id="parent_code"
              v-model="commune.parent_code"
              :placeholder="$t('label.districtOrCityCode')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.parent_code">
              <FiledIsRequired :msg="validations['parent_code'][0]" />
            </template>
          </div>
        </div>

        <div
          v-if="$route.name === 'create-commune'"
          :class="{ 'has-error': validations.district_id }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="district_id"
          >{{ $t("label.districtOrCityId") }}</label>
          <div class="col-sm-9">
            <input
              id="district_id"
              v-model="commune.district_id"
              :placeholder="$t('label.districtOrCityId')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.district_id">
              <FiledIsRequired :msg="validations['district_id'][0]" />
            </template>
          </div>
        </div>

        <div
          :class="{ 'has-error': validations.name_km }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="name_km"
          >{{ $t("label.nameInKhmer") }}</label>
          <div class="col-sm-9">
            <input
              id="name_km"
              v-model="commune.name_km"
              :placeholder="$t('label.name_km')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_km">
              <FiledIsRequired :msg="validations['name_km'][0]" />
            </template>
          </div>
        </div>

        <div
          :class="{ 'has-error': validations.name_en }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="name_en"
          >{{ $t("label.nameInEnglish") }}</label>
          <div class="col-sm-9">
            <input
              id="name_en"
              v-model="commune.name_en"
              :placeholder="$t('label.name_en')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_en">
              <FiledIsRequired :msg="validations['name_en'][0]" />
            </template>
          </div>
        </div>

        <div
          :class="{ 'has-error': validations.type_km }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="type_km"
          >{{ $t("label.typeInKhmer") }}</label>
          <div class="col-sm-9">
            <input
              id="type_km"
              v-model="commune.type_km"
              :placeholder="$t('label.typeInKhmer')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.type_km">
              <FiledIsRequired :msg="validations['type_km'][0]" />
            </template>
          </div>
        </div>

        <div
          :class="{ 'has-error': validations.type_en }"
          class="form-group"
        >
          <label
            class="col-sm-3 control-label required"
            for="type_en"
          >{{ $t("label.typeInEnglish") }}</label>
          <div class="col-sm-9">
            <input
              id="type_en"
              v-model="commune.type_en"
              :placeholder="$t('label.typeInEnglish')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.type_en">
              <FiledIsRequired :msg="validations['type_en'][0]" />
            </template>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-9">
            <button
              class="btn btn-primary btn-sm margin-r-5"
              @click="onSubmit"
            >
              <i class="fa fa-check-circle" /> {{ $t("button.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FiledIsRequired from '@/components/FiledIsRequired'
export default {
  name: 'Form',
  components: { FiledIsRequired },
  data () {
    return {
      commune: {
        code: null,
        parent_code: null,
        district_id: null,
        name_en: null,
        name_km: null,
        type_en: null,
        type_km: null
      },
      validations: {}
    }
  },
  mounted () {
    if (this.$route.name === 'edit-commune') {
      this.fetchDistrict()
    }
  },
  methods: {
    onSubmit () {
      this.validations = {}
      this.$isLoading(true)
      this.$axios
        .post(
          process.env.VUE_APP_API + '/api/backend/commune/store',
          this.commune
        )
        .then(() => {
          this.showToastr()
          this.$router.push({
            name: 'list-commune'
          })
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    fetchDistrict () {
      this.$isLoading(true)
      this.$axios
        .post(process.env.VUE_APP_API + '/api/backend/commune/show', {
          id: this.$route.params.id
        })
        .then((response) => {
          if (response.data && response.data.data) {
            this.commune = response.data.data
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped></style>
